import axios from "axios";

export default axios.create({
  baseURL:"https://sopag.sistemasiepac.mx/api",
  headers:{
    "Content-type":"application/json"
  }
})